
import { defineComponent } from 'vue'
import { IconType } from '@/enums/IconType'
import Icon from '@/components/base/Icon.vue'
import { useHistory } from '@/hooks/useHistory'
import { HistoryQueryStringType } from '@/enums/queryString'

export default defineComponent({
  name: 'FullscreenPopup',
  components: {
    Icon,
  },
  emits: ['close'],
  props: {
    title: String,
  },
  setup(_, { emit }) {
    useHistory(HistoryQueryStringType.FULLSCREEN_POPUP, () => emit('close'))
    return {
      IconType,
    }
  },
})
